import React from "react";
import { useParams } from "react-router-dom";
import destinations from "../data/destinations.json";

const DestinationPage = () => {
  const { name } = useParams(); // Get the dynamic `name` from the URL
  const destination = destinations.find(
    (dest) => dest.name.toLowerCase() === name.toLowerCase()
  ); // Match destination by name (case-insensitive)

  if (!destination) {
    return (
      <div className="p-8">
        <h1 className="text-4xl font-bold">Destination Not Found</h1>
        <p className="text-gray-600">
          The destination you're looking for doesn't exist.
        </p>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold mb-4">{destination.name}</h1>
      <img
        src={destination.image}
        alt={`${destination.name}From Unsplash`}
        className="w-full h-64 object-cover rounded-lg mb-4"
      />
      <p className="text-gray-600 mb-6">{destination.description}</p>
      <h2 className="text-2xl font-bold mb-4">Weekly Itinerary</h2>
      <ul className="list-disc list-inside text-gray-600">
        {destination.itinerary.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default DestinationPage;
